import { Job, JobType } from "./job";

export class BaleJob extends Job {
    onLocation: Location = [];
    atCustomerId: string = "";
    toCustomerId: string ="";
    type: JobType = JobType.BALING;
}